/**
 * explanation-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Richard A Arriaga <rarriaga@safetyweb.org>
 */

import { IncomingMessage } from "../../general/incoming-message";
import { MessageTag } from "../../message-tag";

export interface AbbreviatedEdge {
  source : number;
  target : number;
}

/**
 * After a server successfully processes an {@link ExplanationRequest}
 * by constructing a graph, the server will respond to the client with an
 * {@link ExplanationResponse} that contains the form of the explanation.
 */
export class ExplanationResponse extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.RSP_EXPLANATION;

  public explanation : number;
  public edges : AbbreviatedEdge[];
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/algorithms/graphs/explanation-response.ts